import { portalPageRegistry } from "./internalPortalPages";
import type { PortalPageKey } from "./portalPages";

export const portalConfig: {
  baseName: string;
  portalTitle: string;
  enabledPages: PortalPageKey[];
} = {
  baseName: "jdx-docforce-portal",
  portalTitle: "Jordex IT Portal",
  enabledPages: portalPageRegistry.map((page) => page.key),
};
